import { combineReducers } from 'redux';
import breakoutReducer from '../routes/BreakOutMode/reducer';

// we used combineReducers() to combine several reducers into one
const reducer = combineReducers({
  main: breakoutReducer
});

export default reducer;



// WEBPACK FOOTER //
// ./src/config/reducer.js